<template>
  <div class="follow_goods">
    <div class="title">
      <span>收藏的商品</span>
    </div>
    <div class="con_tent">
      <div class="type">
        <div class="type_title">分类：</div>
        <div class="value">
          <span :class="{ active: curCateId == '', item: true, com_link: true }" @click="search('')">全部商品</span>
          <span :class="{
                active: curCateId == item.id,
                item: true,
                com_link: true,
              }" v-for="(item, index) in categoryList" :key="index" @click="search(item.id)">
            {{ item.name }}
          </span>
        </div>
      </div>
      <ul class="screen">
        <li class="screen_title">筛选条件：</li>
        <li>
          <el-checkbox v-model="selectAll" @change="selectChange">全选</el-checkbox>
        </li>
        <li class="com_link" @click="batchAddShoppingCart">
          <img :src="require('@/assets/img/my06.png')" alt />
          加入购物车
        </li>
        <li class="com_link" @click="batchCancelFollowGoods">
          <img :src="require('@/assets/img/my05.png')" alt />
          取消收藏
        </li>
        <li class="btn_box">
          <el-button class="btn" type="info" v-if="!batchAction" @click="batchAction = true">批量操作</el-button>
          <el-button class="btn" type="info" v-else @click="cancelAction">取消</el-button>
        </li>
      </ul>
      <!-- 商品数据 -->
      <ul class="goods_list">
        <li class="goods_item" :class="selectAll ? 'active' : ''" v-for="(item, index) in list" :key="index">
          <div class="img_box">
            <div class="img_box_scale">
              <router-link :to="{path:'/goodsDetails/'+item.goodsMixSerNo+'.html'}" target="_blank">
                <img v-lazy="item.mainPreviewImageFilePath" alt="图片加载失败" />
              </router-link>
            </div>
          </div>
          <div class="name">
            <router-link :to="{path:'/goodsDetails/'+item.goodsMixSerNo+'.html'}" target="_blank">
              <span class="com_link">{{ item.goodsName+item.goodsMixName }}</span>
            </router-link>
          </div>
          <div class="price">
            <span>￥{{ item.curSalePrice | priceValue }}</span>
          </div>
          <div class="reduce">
            <div class="icon" v-if="item.salePrice - item.curSalePrice > 0">
              降
            </div>
            <span v-if="item.salePrice - item.curSalePrice > 0">比关注时降价￥{{ item.salePrice - item.curSalePrice }}</span>
          </div>
          <!-- <div class="comment">
              <p>
                <img :src="require('@/assets/img/my02.png')" alt />
                <span>1235人评价</span>
              </p>
              <p>
                <img :src="require('@/assets/img/my04.png')" alt />
                <span>98%</span>
              </p>
            </div> -->
          <div class="action">
            <div class="cur_pointer" @click="cancelFollowGoods(item.id)">
              <img :src="require('@/assets/img/my05.png')" alt />
              <span class="com_link">取消收藏</span>
            </div>
            <div class="cur_pointer" @click="addShoppingCart(item.goodsMixId,item.id)">
              <img :src="require('@/assets/img/my06.png')" alt />
              <span class="com_link">加入购物车</span>
            </div>
          </div>
          <i class="i-check el-icon-check" :class="item.checked ? 'select' : ''" v-if="batchAction" @click="selectItem(item)"></i>
          <div class="item-mask" v-if="batchAction"></div>
        </li>
        <div class="no_goods" v-if="list.length == 0">暂无收藏商品</div>
      </ul>
      <el-pagination class="pagination" background @current-change="handleCurrentChange" :current-page="pageInfo.pageNumber" :page-size="pageInfo.pageSize" layout="total, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import onlyMessage from "@/pages/publicUtils/resetMessage.js";
export default {
  metaInfo: { title: "收藏商品 - 个人中心" },
  name: "followGoods",
  props: {
    GetCollCategoryList: {
      type: Function,
      default: () => {},
    },
    GetfollowGoodsList: {
      type: Function,
      default: () => {},
    },
    AddShopCart: {
      type: Function,
      default: () => {},
    },
    DelCollection: {
      type: Function,
      default: () => {},
    },
    BatchAddShopCart: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      curCateId: "",
      categoryList: [],
      selectAll: false,
      list: [],
      pageInfo: {
        pageNumber: 1,
        pageSize: 8,
        searchProperty: [],
        orderProperty: [],
      },
      total: 0,
      batchAction: false,
    };
  },
  mounted() {
    this.getCategoryList();
    this.getfollowGoodsList();
  },
  methods: {
    getCategoryList() {
      this.GetCollCategoryList({}).then((res) => {
        // console.log("获取分类", res);
        this.categoryList = res.data;
      });
    },
    getfollowGoodsList() {
      this.batchAction = false;
      let params = {
        categoryId: this.curCateId,
        pageInfo: this.pageInfo,
      };
      this.GetfollowGoodsList(params).then((res) => {
        // console.log("获取收藏商品列表", res);
        this.list = res.data;
        this.total = res.count;
        this.list.forEach((v) => {
          this.$set(v, "checked", false);
        });
      });
    },
    // 搜索
    search(id) {
      this.curCateId = id;
      this.pageInfo.pageNumber = 1;
      this.getfollowGoodsList();
    },
    // 全选change
    selectChange(val) {
      // console.log(val);
      this.batchAction = val;
      this.list.forEach((item) => {
        item.checked = val;
      });
    },
    // 单选
    selectItem(item) {
      item.checked = !item.checked;
    },
    // 取消选择
    cancelAction() {
      this.batchAction = false;
      this.list.forEach((item) => {
        item.checked = false;
      });
    },
    // 单个加入购物车
    addShoppingCart(goodsMixId, id) {
      let params = {
        goodsMixId,
        goodsMixCount: 1,
        collectionId: id,
        regionCode: localStorage.getItem("_regionCode"),
      };
      this.AddShopCart(params).then((res) => {
        // console.log("加入购物车结果", res);
        onlyMessage.success("加入成功");
        this.$store.commit("SET_SHOPCARTNUM");
        this.pageInfo.pageNumber = 1;
        this.getfollowGoodsList();
      });
    },
    // 取消收藏
    cancelFollowGoods(id) {
      this.$confirm("取消关注，确定吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.DelCollection({ id }).then((res) => {
            // console.log("取消收藏", res);
            this.cancelAction();
            this.pageInfo.pageNumber = 1;
            this.getfollowGoodsList();
          });
        })
        .catch(() => {});
    },
    // 批量
    batchAddShoppingCart() {
      if (this.checkedList.length === 0) {
        this.$alert("请至少选中一件商品", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
        return;
      }
      let arr = [];
      this.checkedList.forEach((item) => {
        arr.push({
          goodsMixId: item.goodsMixId,
          goodsCount: 1,
          collectionId: item.id,
        });
      });
      let params = {
        regionCode: localStorage.getItem("_regionCode"),
        shoppingCartList: arr,
      };
      this.BatchAddShopCart(params).then((res) => {
        // console.log("批量加入购物车", res);
        onlyMessage.success("加入成功");
        this.$store.commit("SET_SHOPCARTNUM");
        this.pageInfo.pageNumber = 1;
        this.getfollowGoodsList();
      });
    },
    batchCancelFollowGoods() {
      if (this.checkedList.length === 0) {
        this.$alert("请至少选中一件商品", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showClose: false,
        });
        return;
      }
      let id = "";
      this.checkedList.forEach((item, index) => {
        if (index == 0) {
          id = item.id;
        } else {
          id += "," + item.id;
        }
      });
      this.cancelFollowGoods(id);
    },
    // 分页
    handleCurrentChange(val) {
      // console.log(val);
      this.pageInfo.pageNumber = val;
      this.cancelAction();
      this.getfollowGoodsList();
    },
  },
  computed: {
    // 选中的item
    checkedList() {
      let arr = [];
      this.list.forEach((v) => {
        if (v.checked == true) {
          arr.push(v);
        }
      });
      return arr;
    },
  },
  watch: {
    checkedList: {
      handler(newV, oldV) {
        // console.log(newV);
        if (newV.length == 0) {
          this.selectAll = false;
          return;
        }
        if (newV.length === this.list.length) {
          this.selectAll = true;
        } else {
          this.selectAll = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.follow_goods {
  .title {
    height: 40px;
    line-height: 40px;
    padding: 0px 31px;
    background: rgba(244, 244, 244, 1);
  }
  .con_tent {
    border: 1px solid #f4f4f4;
    box-sizing: border-box;
    margin: 14px 0 35px;
    padding: 16px 36px 52px 32px;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    overflow: hidden;
    position: relative;
    .type {
      margin-bottom: 20px;
      overflow: auto;
      .type_title {
        width: 70px;
        margin-right: 30px;
        float: left;
      }
      .value {
        margin-left: 100px;
        .item {
          display: inline-block;
          padding: 2px 8px;
          margin: 0 4px 4px 0;
          font-size: 12px;
          cursor: pointer;
        }
        .active {
          color: #fff !important;
          background-color: @themeColor;
        }
      }
    }
    .screen {
      display: flex;
      margin-bottom: 20px;
      position: relative;
      line-height: 24px;
      .screen_title {
        min-width: 70px;
        margin-right: 30px;
        cursor: text;
      }
      li {
        margin-right: 20px;
        cursor: pointer;
        /deep/ .el-checkbox {
          .el-checkbox__label {
            line-height: 14px;
            padding-left: 6px;
          }
          .el-checkbox__input {
            line-height: 14px;
          }
        }
        img {
          width: 14px;
          height: 14px;
          vertical-align: middle;
        }
      }
      .btn_box {
        position: absolute;
        right: 0px;
        .btn {
          padding: 4px 15px;
          font-size: 12px;
          border-radius: 0px;
        }
      }
    }
    .goods_list {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 30px;
      .goods_item {
        width: 220px;
        // height: 353px;
        border: 1px solid #f4f4f4;
        box-sizing: border-box;
        margin-right: 56px;
        margin-bottom: 12px;
        padding-bottom: 4px;
        position: relative;
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:hover {
          box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
          .img_box_scale {
            transform: scale(1.2);
          }
        }
        .img_box {
          width: 200px;
          height: 200px;
          margin: 0 auto;
          overflow: hidden;
          cursor: pointer;
          .img_box_scale {
            width: 100%;
            height: 100%;
            transition: all 0.5s;
            -moz-transition: all 0.5s; /* Firefox 4 */
            -webkit-transition: all 0.5s; /* Safari and Chrome */
            -o-transition: all 0.5s; /* Opera */
          }
        }
        .name {
          width: 180px;
          height: 37px;
          margin: 0 auto;
          text-align: center;
          line-height: 37px;
          border-bottom: 1px solid #f4f4f4;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          a {
            color: #000000;
          }
        }
        .price {
          padding: 8px 0;
          text-align: center;
          font-weight: 800;
        }
        .reduce {
          text-align: center;
          line-height: 38px;
          height: 38px;
          font-size: 12px;
          color: @themeColor;
          .icon {
            display: inline-block;
            width: 16px;
            height: 16px;
            margin-right: 10px;
            background-color: @themeColor;
            color: #fff;
            line-height: 16px;
            border-radius: 50%;
          }
        }
        .comment {
          display: flex;
          justify-content: space-between;
          height: 27px;
          line-height: 27px;
          box-sizing: border-box;
          padding: 0 12px;
          font-size: 12px;
          border-top: 1px solid #f4f4f4;
          img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
            padding-right: 6px;
          }
          span {
            vertical-align: middle;
          }
        }
        .action {
          height: 27px;
          line-height: 27px;
          box-sizing: border-box;
          font-size: 12px;
          border-top: 1px solid #f4f4f4;
          padding: 0 12px;
          display: flex;
          justify-content: space-between;
          img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
            padding-right: 6px;
          }
          span {
            vertical-align: middle;
          }
        }
        .item-mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: #000;
          filter: alpha(opacity=30);
          -moz-opacity: 0.3;
          opacity: 0.3;
          z-index: 22;
        }
        .i-check {
          position: absolute;
          right: 0px;
          top: 0px;
          width: 40px;
          height: 40px;
          background-color: #666;
          cursor: pointer;
          color: #fff;
          font-size: 30px;
          line-height: 40px;
          text-align: center;
          z-index: 33;
        }
        .select {
          background-color: rgb(228, 57, 60);
        }
      }
      .no_goods {
        width: 100%;
        height: 150px;
        text-align: center;
        line-height: 150px;
      }
      .active {
        .checked {
          display: block;
        }
      }
    }
    .pagination {
      text-align: right;
    }
  }
}
</style>